"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var FontAwesome_1 = require("../../../../../../../../shared/components/icons/FontAwesome");
var BonusTournamentsLocalesTplEditDescription_1 = require("./BonusTournamentsLocalesTplEditDescription");
var BonusTournamentsLocalesTplViewParam_1 = require("./BonusTournamentsLocalesTplViewParam");
var BonusTournamentsLocales = /** @class */ (function (_super) {
    __extends(BonusTournamentsLocales, _super);
    function BonusTournamentsLocales(props) {
        var _this = _super.call(this, props) || this;
        _this.tab_description = "tab.description";
        _this.tab_test = "tab.test";
        return _this;
    }
    BonusTournamentsLocales.prototype.componentWillMount = function () {
        this.props.state.setExtBreadCrumbPath(["Шаблоны локализации турнира"]);
    };
    BonusTournamentsLocales.prototype.backToRootClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BonusTournamentsLocales.prototype.getTestJSONViewObject = function () {
        return (React.createElement(BonusTournamentsLocalesTplViewParam_1.default, { data: this.props.data, record: this.props.record, state: this.props.state, onGoBack: this.backToRootClick.bind(this), dialogViewText: this.props.dialogViewText }));
    };
    BonusTournamentsLocales.prototype.GetWagerDescriptionTab = function () {
        //Вейджер:Описание
        return (React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                React.createElement(FontAwesome_1.FA, { left: true, icon: "comment-dots" }),
                "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"), key: this.tab_description },
            React.createElement(BonusTournamentsLocalesTplEditDescription_1.default, { data: this.props.data, record: this.props.record, state: this.props.state, onGoBack: this.backToRootClick.bind(this), dialogViewText: this.props.dialogViewText })));
    };
    BonusTournamentsLocales.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(antd_1.Tabs, { defaultActiveKey: this.tab_description },
                this.GetWagerDescriptionTab(),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "check-circle" }),
                        "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430"), key: this.tab_test }, this.getTestJSONViewObject()))));
    };
    return BonusTournamentsLocales;
}(React.Component));
exports.default = BonusTournamentsLocales;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ui/component/options/locales/BonusTournamentsLocales.tsx
// module id = 2517
// module chunks = 0